import React, { useState } from 'react';
import {
  Input, Tabs, Button, message, Form, Space,
} from 'antd';
import './ForgotPassword.css';
import { MailOutlined } from '@ant-design/icons';
import Axios from 'axios';
import { url } from '../../config/global';

import LogoTes from '../../assets/img/icon-sidebar-small.png';

const { TabPane } = Tabs;

function ForgotPassword(props) {
  const [tab, setTab] = useState('1');
  const [login] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({
    email: '',
  });

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...login,
      [name]: value,
    });
  };

  const onSaveData = () => {
    setLoading(true);

    Axios.post(
      `${url}/forgot-password`,
      {
        email: data.email,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      },
    )
      .then((res) => {
        message.success(res.data.message);
        props.history.push('/login');
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
        setLoading(false);
      });
  };

  const handleTab = (key) => {
    setTab(key);
  };

  return (
    <div className="main">
      <div>
        <img
          src={LogoTes}
          className="img-logo"
          alt="DEM"
        />
        <h2 className='brand-text text-success ml-1'>PT. DHARMA POLIMETAL</h2>

        <Tabs activeKey={tab} onChange={handleTab}>
          <TabPane tab="Forgot Password" key="1">
            <Form onFinish={onSaveData}>
              <Form.Item
                validateStatus={error && error.email ? 'error' : false}
                help={error && error.email ? error.email[0] : false}
              >
                <Input
                  className="login-input"
                  prefix={<MailOutlined />}
                  placeholder="Email Active"
                  onChange={(e) => handleChange('email', e.target.value)}
                  value={data.email}
                />
              </Form.Item>

              <div>
                <Space>
                  <Button
                    htmlType="submit"
                    loading={loading}
                    // onClick={handleLogin}
                    type="primary"
                    className="button-login"
                  >
                    Send Token
                  </Button>
                </Space>
              </div>
            </Form>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default ForgotPassword;
